/**
 * @generated SignedSource<<8b1e81390a68e04b7eee2c994f46e913>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"experienceRegistry_issueNavigator_SidebarExperienceRegistry_project">;
  readonly " $fragmentType": "experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_project";
};
export type experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_project$key = {
  readonly " $data"?: experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isSavedViewConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_project",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        },
        {
          "kind": "Variable",
          "name": "isSavedViewConditionalFormattingEnabled",
          "variableName": "isSavedViewConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistry_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "68c529d353dff98f98ffde69ce1a3cbe";

export default node;
